import { Card, CircularProgress } from "@material-ui/core";
import React, { Component } from "react";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import { Image } from "react-bootstrap";
import DiagramMhsAktif from "./../../component/Mahasiswa/Widget/DiagramMhsAktif";
// import DiagramIPK from "./../../component/Mahasiswa/Widget/DiagramIPK";
// import DiagramMasaStudi from "./../../component/Mahasiswa/Widget/DiagramMasaStudi";
import DiagramMhsAsing from "./../../component/Mahasiswa/Widget/DiagramMhsAsing";
import DiagramDosenTetap from "./../../component//Dosen/Widget/DiagramDosenTetap";
import DiagramDosenSertifikasi from "./../../component/Dosen/Widget/DiagramDosenSertifikasi";
import DiagramJabFung from "./../../component/Dosen/Widget/DiagramJabFung";
import axios from "axios";
// import PengabdianMasyarakatPT from "./../../component/Pengabdian/pt/PengabdianMasyarakatPT";
import AppConfig from "../../../../config/AppConfig";
import DiagramDosenTidakTetap from "../../component/Dosen/Widget/DiagramDosenTidakTetap";

class SemuaPT extends Component {
  state = {
    loading: false,
    DiagramMhsAktif: [],
    DiagramMhsAsingPindahan: [],
    DiagramIkatan: [],
    DataPT: [],
  };
  componentDidMount() {
    console.log("props : ", this.props);
    let userdata = JSON.parse(localStorage.getItem("userdata"));
    let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
    let session = "";
    let id_sp_p = sessiondata.i_idunit;
    if (userdata) {
      let id_sms = "";
      if (sessiondata.i_idsms !== undefined) {
        id_sms = "&id_sms=" + sessiondata.i_idsms;
      }
      if (this.props.idSp !== undefined) {
        console.log("A");
        id_sp_p = this.props.idSp;
        session = "?id_sp=" + this.props.idSp + id_sms;
      } else {
        session = "?id_sp=" + sessiondata.i_idunit + id_sms;
        console.log("B");
      }
    }
    let data_mhs = AppConfig.MhsTerdaftar + session;
    let data_dosen = AppConfig.DosenIkatan + session;
    let rq_mhs = axios.get(data_mhs);
    let data1 = AppConfig.Profile + "/" + id_sp_p;
    let rq = axios.get(data1);
    let rq_dosen = axios.get(data_dosen);
    axios
      .all([rq_mhs, rq_dosen, rq])
      .then(
        axios.spread((...responses) => {
          let respon_mhs = responses[0];
          let respon_dosen = responses[1];
          let respon = responses[2];
          let data_mhs_baru = respon_mhs.data.result.data_mhs_baru;
          let last_key_mhs_aktif = Object.keys(data_mhs_baru)[
            Object.keys(data_mhs_baru).length - 1
          ];

          let data_mhs = {
            data_mhs_baru: respon_mhs.data.result.data_mhs_baru,
            data_mhs_asing: respon_mhs.data.result.data_mhs_asing,
            totalmahasiswa:
              (Object.keys(data_mhs_baru).length > 0) ? respon_mhs.data.result.data_mhs_baru[last_key_mhs_aktif].aktif : "0",
            display: true,
          };

          let jumdosen = respon_dosen.data.result.jumdosen;
          console.log(jumdosen);
          let last_key_jumdosen =
            jumdosen[Object.keys(jumdosen)[Object.keys(jumdosen).length - 1]];
          console.log(last_key_jumdosen);

          let data_dosen_ikatan = {
            data_dosen_ikatan: respon_dosen.data.result.dataikatan,
            data_dosen_jabfung: respon_dosen.data.result.datajabfung,
            data_dosen_dosen_sertifikasi:
              respon_dosen.data.result.dosen_sertifikasi,
            jumdosen: respon_dosen.data.result.jumdosen,
            totaldosen: last_key_jumdosen.toString(),
            display: true,
          };
          this.setState(
            {
              DiagramMhsAktif: data_mhs,
              DiagramMhsAsingPindahan: data_mhs,
              DiagramIkatan: data_dosen_ikatan,
              loading: true,
              DataPT: respon.data,
            },
            () => {
              console.log(this.state.DiagramIkatan);
            }
          );
        })
      )
      .catch((errors) => {
        console.log(errors);
      });
  }
  componentDidUpdate() {
    let id_sms = "";
    if (this.props.displayProdi === true) {
      id_sms = "&id_sms=" + this.props.idSms;

      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let sessiondata = JSON.parse(localStorage.getItem("sessiondata"));
      let session = "";
      if (userdata) {
        if (this.props.idSp !== undefined) {
          session = "?id_sp=" + this.props.idSp + id_sms;
        } else {
          session = "?id_sp=" + sessiondata.i_idunit + id_sms;
        }
      }
      let data_mhs = AppConfig.MhsTerdaftar + session;
      let data_dosen = AppConfig.DosenIkatan + session;
      let rq_mhs = axios.get(data_mhs);
      let rq_dosen = axios.get(data_dosen);
      let data1 = AppConfig.Profile + "/" + this.props.id_sp;
      let rq = axios.get(data1);
      axios
        .all([rq_mhs, rq_dosen, rq])
        .then(
          axios.spread((...responses) => {
            let respon_mhs = responses[0];
            let respon_dosen = responses[1];
            let respon = responses[2];
            let data_mhs_baru = respon_mhs.data.result.data_mhs_baru;
            let last_key_mhs_aktif = Object.keys(data_mhs_baru)[
              Object.keys(data_mhs_baru).length - 1
            ];
            console.log(respon_dosen);

            let data_mhs = {
              data_mhs_baru: respon_mhs.data.result.data_mhs_baru,
              data_mhs_asing: respon_mhs.data.result.data_mhs_asing,
              totalmahasiswa:
                respon_mhs.data.result.data_mhs_baru[last_key_mhs_aktif].aktif,
              display: true,
            };

            let jumdosen = respon_dosen.data.result.jumdosen;
            let last_key_jumdosen =
              jumdosen[Object.keys(jumdosen)[Object.keys(jumdosen).length - 1]];

            let data_dosen_ikatan = {
              data_dosen_ikatan: respon_dosen.data.result.dataikatan,
              data_dosen_jabfung: respon_dosen.data.result.datajabfung,
              data_dosen_dosen_sertifikasi:
                respon_dosen.data.result.dosen_sertifikasi,
              jumdosen: respon_dosen.data.result.jumdosen,
              totaldosen: last_key_jumdosen.toString(),
              display: true,
            };
            this.setState({
              DiagramMhsAktif: data_mhs,
              DiagramMhsAsingPindahan: data_mhs,
              DiagramIkatan: data_dosen_ikatan,
              loading: true,
              DataPT: respon.data,
            });
            this.props.handleCallbackDisplayProdi(false);
            this.props.handleCallbackSearch(false);
          })
        )
        .catch((errors) => {
          console.log(errors);
        });
    }
    if (this.props.resetProdi === true) {
      this.componentDidMount();
      this.props.handleCallbackResetProdi(false);
    }
  }
  render() {
    let { loading } = this.state;
    let display_data = [];
    if (loading === true) {
      display_data = (
        <div className="row row-paddingless">
          <div className="col-md-4" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px", height: "98%" }}>
              <br />
              <div style={{ marginTop: "5%" }}>
                <span className="svg-icon">
                  <Image
                    style={{ width: "30%" }}
                    src={toAbsoluteUrl("/media/logos/mhs.png")}
                  />
                </span>
                <h1
                  className="font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "35px" }}
                >
                  {this.state.DataPT.result.profile.totalmahasiswa}
                </h1>
                <h5
                  className="card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  MAHASISWA
                </h5>
              </div>
              <div>
                <span className="svg-icon">
                  <Image
                    style={{ width: "30%" }}
                    src={toAbsoluteUrl("/media/logos/dosen.png")}
                  />
                </span>
                <h1
                  className="font-weight-bolder"
                  style={{ color: "#354f7a", fontSize: "35px" }}
                >
                  {this.state.DiagramIkatan.totaldosen}
                </h1>
                <h5
                  className="card-title font-weight-bolder"
                  style={{ color: "#354f7a" }}
                >
                  DOSEN
                </h5>
              </div>
            </Card>
          </div>
          <div className="col-md-8" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px" }}>
              <DiagramMhsAktif dataMhs={this.state.DiagramMhsAktif} />
            </Card>
          </div>
          {/* <div className="col-md-12" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramIPK/>
                    </Card>
                </div>
                <div className="col-md-6" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <DiagramMasaStudi/>
                    </Card>
                </div> */}
          <div className="col-md-6" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px" }}>
              <DiagramMhsAsing dataMhs={this.state.DiagramMhsAsingPindahan} />
            </Card>
          </div>
          <div className="col-md-6" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px" }}>
              <DiagramDosenSertifikasi dataDosen={this.state.DiagramIkatan} />
            </Card>
          </div>
          <div className="col-md-12" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px" }}>
              {/* <DiagramIkatanKerja dataDosen={this.state.DiagramIkatan}/> */}
              <DiagramDosenTetap dataDosen={this.state.DiagramIkatan} />
            </Card>
          </div>
          <div className="col-md-6" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px" }}>
              <DiagramDosenTidakTetap dataDosen={this.state.DiagramIkatan} />
            </Card>
          </div>
          <div className="col-md-6" style={{ textAlign: "center" }}>
            <Card style={{ margin: "5px" }}>
              <DiagramJabFung dataDosen={this.state.DiagramIkatan} />
            </Card>
          </div>
          {/* <div className="col-md-12" style={{textAlign:'center'}}>
                    <Card  style={{margin:"5px"}}>
                        <PengabdianMasyarakatPT/>
                    </Card>
                </div> */}
        </div>
      );
    } else {
      display_data = (
        <div
          style={{
            width: "100%",
            marginTop: "10%",
            textAlign: "center",
            verticalAlign: "middle",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      );
    }
    return display_data;
  }
}
export default SemuaPT;
